// TODO: extract to common package when shared utilities are created
// This logic is also duplicated in apps/services/src/commons/utils.ts
import * as config from '../commons/config';
export const PRE_MULTIREGION_PROJECTID_LENGTH = 16;

export const regionPrefixMap = {
    'us-west-2': 'usw2',
    'eu-central-1': 'euc1',
} as const;

// The opposite of regionPrefixMap, so we can get the region from the projectId
export const prefixRegionMap = Object.fromEntries(
    Object.entries(regionPrefixMap).map(([k, v]) => [v, k])
) as { [K in keyof typeof regionPrefixMap as typeof regionPrefixMap[K]]: K };

export function getRegionFromProjectId(projectId: string): 'usw2' | 'euc1' | undefined {
    const regionRegex = new RegExp(`^\\b(${Object.values(regionPrefixMap).join('|')})`);
    const extractedRegion = regionRegex.exec(projectId)?.[0];
    if (extractedRegion) {
        return extractedRegion as 'usw2' | 'euc1';
    }
    const fallbackRegion = regionPrefixMap[config.TESTIM_REGION as keyof typeof regionPrefixMap] || 'usw2';
    return fallbackRegion;
}
